import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { AuthHttp } from "angular2-jwt/angular2-jwt";
import { SessionStorageService } from "ngx-webstorage/dist/services";
import { ConstantService } from "../../../components/common/utils/constant.service";
import { ClienteLogin, Cliente, ClienteXCiudad } from "../../login/cliente_login";
import { Headers, Http, Response, RequestOptions, ResponseContentType } from '@angular/http';
import { PolizaEntity, ConsultaPoliza } from "../entities/polizas_cliente_entity";
import { ObjMultiSelectPolizas } from '../entities/vam_entities';

declare var jQuery: any;

@Injectable()
export class PolizasContratadasService {
    private userEmpresa: ClienteXCiudad;
    private url = "datosGeneralesEmpresa";
    private urlMovimientos = "movimientos";

    constructor(private authHttp: AuthHttp, private sessionStorageService: SessionStorageService) {
        let constantService = new ConstantService();
        this.url = constantService.API_ENDPOINT + this.url;
        this.urlMovimientos = constantService.API_ENDPOINT + this.urlMovimientos;
    }

    consultaPolizasContratadas(segmento: number, segmentoAlterno): Observable<PolizaEntity[]> {
        try {
            this.userEmpresa = jQuery.parseJSON(this.sessionStorageService.retrieve("usuarioEmpresa"));
        } catch (e) {
            this.userEmpresa = this.sessionStorageService.retrieve("usuarioEmpresa");
        }
        let consulta = new ConsultaPoliza();
        consulta.Cliente = this.userEmpresa;
        consulta.Segmento = segmento;
        consulta.SegmentoAlterno = segmentoAlterno;
        let body = JSON.stringify(consulta);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/consultaPolizasContratadas", body, options).map(this.extractData)
            .catch(this.handleError);
    }

    generarListado(poliza: PolizaEntity):Observable<any>{
        let body = JSON.stringify(poliza);
        let headers = new Headers({
            'Content-Type': 'application/json',
            'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'Authorization' : "Token " + sessionStorage.getItem("Token")
        });
        let options = new RequestOptions({ headers: headers });
        options.responseType = ResponseContentType.Blob;
        return this.authHttp.post(this.urlMovimientos + "/listado/", body, options)
            .map(response => response).catch(this.handleError);
    }
    consultaListaPolizas(segmento: number, segmentoAlterno): Observable<ObjMultiSelectPolizas[]> {
        try {
            this.userEmpresa = jQuery.parseJSON(this.sessionStorageService.retrieve("usuarioEmpresa"));
        } catch (e) {
            this.userEmpresa = this.sessionStorageService.retrieve("usuarioEmpresa");
        }
        let consulta = new ConsultaPoliza();
        consulta.Cliente = this.userEmpresa;
        consulta.Segmento = segmento;
        consulta.SegmentoAlterno = segmentoAlterno;
        let body = JSON.stringify(consulta);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/consultaListPolizasContratadas", body, options).map(this.extractData)
            .catch(this.handleError);
    }
    generarResumen(poliza: PolizaEntity):Observable<any>{
        let body = JSON.stringify(poliza);
        let headers = new Headers({
            'Content-Type': 'application/json',
            'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'Authorization' : "Token " + sessionStorage.getItem("Token")
        });
        let options = new RequestOptions({ headers: headers });
        options.responseType = ResponseContentType.Blob;
        return this.authHttp.post(this.url + "/ConsultaResumenSeguros/", body, options)
            .map(response => response).catch(this.handleError);
    }
    private extractData(res: Response) {
        let body = res.json();
        return body || {};
    }
    private handleError(error: any) {
        return Observable.throw(error);
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/polizasContratadas/polizas-contratadas.service.ts